import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";
const token = localStorage.getItem("token");

export const AnnualPlanAPI = {
  addAnnualPlan: async (data) => {
    var axiosConfig = {
      method: "POST",
      url: `${BASE_URL}add_annualPlanner/`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data,
    };
    return await axios(axiosConfig);
  },
  getAnnualPlan: async (data) => {
    var axiosConfig = {
      method: "POST",
      url: `${BASE_URL}get_annualPlanner/`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    };
    return await axios(axiosConfig);
  },
  deleteAnnualPlan: async (data) => {
    var axiosConfig = {
      method: "POST",
      url: `${BASE_URL}delete_annualPlanner/`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    };
    return await axios(axiosConfig);
  },
};
